import { AppBar, Theme, useMediaQuery } from '@mui/material';
import { MenuWithChildren } from '../../types/menu';
import { Breadcrumb } from '../breadcrumb/Breadcrumb';
import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';
import { useGetSignedInUser } from '../../hooks/useGetSignedInUser';
import _ from 'lodash';
import { APP_URLS } from '../../routes/urls';

export interface HeaderProps {
  isLoading?: boolean;
  menus: MenuWithChildren[];
}
export const Header: React.FC<HeaderProps> = ({ isLoading = false, menus }) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const { isSuccess } = useGetSignedInUser();
  const processedMenus = isSuccess
    ? menus
    : ([
        ...menus,
        { display_name: 'Promote ads', id: _.uniqueId(), link: APP_URLS.adAdminRegister, location: 'Header' },
      ] as MenuWithChildren[]);
  return (
    <AppBar position="sticky" sx={{ bgcolor: 'common.white', boxShadow: 10, borderBottom: 1, borderColor: 'grey.100' }}>
      {isDesktop ? (
        <DesktopHeader menus={processedMenus} isLoading={isLoading} />
      ) : (
        <MobileHeader menus={processedMenus} isLoading={isLoading} />
      )}
      <Breadcrumb />
    </AppBar>
  );
};
